// import React, { useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import { Check, Sparkles, ArrowUpRight } from "lucide-react";
// import Reveal, { SectionLabel } from "../components/Reveal";
// import { Input } from "../components/ui/input";
// import {
//   Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
// } from "../components/ui/select";
// import { Helmet } from "react-helmet-async";

// <Helmet>
// <title>
// Pricing | JustZeta
// </title>

// <meta
// name="description"
// content="Affordable pricing for long-term certificate and research paper preservation starting at ₹1 per participant per year on eligible plans."
// />
// <meta property="og:type" content="website" />

// <meta property="og:site_name" content="JustZeta" />

// <meta property="og:title"
// content="JustZeta - Secure Digital Certificate Preservation"
// />

// <meta property="og:description"
// content="Long-term preservation of digital certificates and research papers."
// />

// <meta property="og:image"
// content="https://justzeta.com/logo.png"
// />

// <meta property="og:url"
// content="https://justzeta.com"
// />
// <meta name="twitter:card" content="summary_large_image"/>

// <meta
// name="twitter:title"
// content="JustZeta"
// />

// <meta
// name="twitter:description"
// content="Secure digital certificate preservation."
// />

// <meta
// name="twitter:image"
// content="https://justzeta.com/logo.png"
// />
// <link
// rel="canonical"
// href="https://justzeta.com/pricing"
// />
// </Helmet>
// const tiers = [
//   {
//     kind: "certificate",
//     name: "Certificate Preservation · Offer",
//     price: "₹1",
//     unit: "/ person / year + GST",
//     conditions: ["Minimum 25 candidates", "Minimum 5 years of storage"],
//     formula: "Candidates × Years × ₹1",
//     accent: true,
//     features: [
//       "Encrypted archival storage",
//       "CSV bulk import",
//       "Verification-ready records",
//       "5+ year retention",
//       "Priority support",
//     ],
//   },
//   {
//     kind: "certificate",
//     name: "Certificate Preservation · Standard",
//     price: "₹5",
//     unit: "/ person / year + GST",
//     conditions: ["Minimum 10 candidates","Minimum 1 year"],
//     formula: "Candidates × Years × ₹5",
//     features: [
//       "Encrypted archival storage",
//       "CSV or manual upload",
//       "Verification-ready records",
//       "Flexible retention (1 yr+)",
//       "Email support",
//     ],
//   },
//   {
//     kind: "conference_paper",
//     name: "Certificate + Paper · Offer",
//     price: "₹5",
//     unit: "/ presenter / year + GST",
//     conditions: ["Minimum 25 presenters", "Minimum 5 years"],
//     formula: "Presenters × Years × ₹5",
//     accent: true,
//     features: [
//       "Certificate storage",
//       "Individual PDF paper storage",
//       "Paper–certificate linking",
//       "5+ year retention",
//       "Priority support",
//     ],
//   },
//   {
//     kind: "conference_paper",
//     name: "Certificate + Paper · Standard",
//     price: "₹15",
//     unit: "/ presenter / year + GST",
//     conditions: ["Minimum 10 candidates","Minimum 1 year"],
//     formula: "Presenters × Years × ₹15",
//     features: [
//       "Certificate storage",
//       "Individual PDF paper storage",
//       "Paper–certificate linking",
//       "Flexible retention (1 yr+)",
//       "Email support",
//     ],
//   },
// ];

// const calculatePrice = (service, participants, years) => {
//   const p = Number(participants) || 0;
//   const y = Number(years) || 0;
//   if (!p || !y) return null;
//   const isCert = service === "certificate";
//   const offerRate = isCert ? 1 : 5;
//   const stdRate = isCert ? 5 : 15;
//   const qualifiesOffer = p >= 25 && y >= 5;
//   const rate = qualifiesOffer ? offerRate : stdRate;
//   const total = p * y * rate;
//   const standardTotal = p * y * stdRate;
//   const savings = Math.max(0, standardTotal - total);
//   return {
//     tier: qualifiesOffer ? "offer" : "standard",
//     rate, total, standardTotal, savings, qualifiesOffer,
//   };
// };

// export default function Pricing() {
//   const [service, setService] = useState("certificate");
//   const [participants, setParticipants] = useState(100);
//   const [years, setYears] = useState(5);

//   const result = useMemo(() => calculatePrice(service, participants, years), [service, participants, years]);
//   const fmt = (n) => n?.toLocaleString("en-IN");

//   return (
//     <div data-testid="page-pricing">
//       {/* HEADER */}
//   <section className="border-b border-white/10 py-24 md:py-32">
//   <div className="max-w-7xl mx-auto px-6 md:px-10">
//     <SectionLabel index={1}>Pricing</SectionLabel>

//     <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
//       <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
//         Simple pricing for
//         <br />
//         <span className="italic text-[#e60000]">
//           long-term digital preservation.
//         </span>
//       </h1>

//       <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
//         Pay only for the participants you archive and the years you choose.
//         No hidden fees, no recurring subscriptions, and no unexpected costs.
//       </p>
//     </div>
//   </div>
// </section>
//       {/* CERTIFICATE TIERS */}
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={2}>Certificate Digital Preservation</SectionLabel>
//           <h2 className="font-serif-display text-4xl md:text-5xl mt-6 max-w-3xl leading-[1.05]">
//             Only certificates. <span className="italic text-neutral-500">Purest archival tier.</span>
//           </h2>

//           <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
//             {tiers.filter((t) => t.kind === "certificate").map((t, i) => (
//               <PriceCard key={t.name} t={t} testid={`price-card-certificate-${i}`} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CONFERENCE PAPER TIERS */}
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={3}>Conference Certificate + Research Paper</SectionLabel>
//           <h2 className="font-serif-display text-4xl md:text-5xl mt-6 max-w-3xl leading-[1.05]">
//             Certificates <span className="italic text-neutral-500">and</span> individual PDF papers, together.
//           </h2>

//           <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
//             {tiers.filter((t) => t.kind === "conference_paper").map((t, i) => (
//               <PriceCard key={t.name} t={t} testid={`price-card-paper-${i}`} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CALCULATOR */}
//       <section className="border-b border-white/10 py-24 md:py-32 relative overflow-hidden">
//         <div className="absolute inset-0 opacity-40 pointer-events-none"
//              style={{ backgroundImage: "radial-gradient(circle at 20% 30%, rgba(230,0,0,0.10), transparent 55%)" }} />
//         <div className="relative max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={4}>Interactive Calculator</SectionLabel>
//           <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
//             Compute your archival budget <span className="italic text-neutral-500">in seconds.</span>
//           </h2>

//           <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-8">
//             {/* Inputs */}
//             <div className="lg:col-span-5 border border-white/10 p-8 md:p-10 bg-[#0a0a0a] space-y-8">
//               <div>
//                 <label className="overline block mb-3">Service Type</label>
//                 <Select value={service} onValueChange={setService}>
//                   <SelectTrigger
//                     data-testid="calc-service-select"
//                     className="bg-transparent border-0 border-b border-white/15 rounded-none focus:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white [&_svg]:text-neutral-400"
//                   >
//                     <SelectValue placeholder="Choose a service" />
//                   </SelectTrigger>
//                   <SelectContent className="bg-[#0a0a0a] border border-white/15 rounded-none">
//                     <SelectItem value="certificate" data-testid="calc-service-certificate">Certificate Preservation</SelectItem>
//                     <SelectItem value="conference_paper" data-testid="calc-service-paper">Certificate + Research Paper</SelectItem>
//                   </SelectContent>
//                 </Select>
//               </div>

//               <div>
//                 <label className="overline block mb-3">Number of Participants</label>
//                 <Input
//                   type="number"
//                   data-testid="calc-participants-input"
//                   min={1}
//                   value={participants}
//                   onChange={(e) => setParticipants(e.target.value)}
//                   className="bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white font-mono-data"
//                 />
//               </div>

//               <div>
//                 <label className="overline block mb-3">Number of Years</label>
//                 <Input
//                   type="number"
//                   data-testid="calc-years-input"
//                   min={1}
//                   value={years}
//                   onChange={(e) => setYears(e.target.value)}
//                   className="bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white font-mono-data"
//                 />
//               </div>

//               <div className="pt-4 text-xs text-neutral-500 leading-relaxed">
//                 Offer tier applies when you meet the volume threshold: 25+ participants and 5+
//                 years. Otherwise, standard rates apply.
//               </div>
//             </div>

//             {/* Output */}
//             <div className="lg:col-span-7">
//               <motion.div
//                 key={`${service}-${participants}-${years}`}
//                 initial={{ opacity: 0, y: 12 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5 }}
//                 className="border border-white/10 bg-[#0a0a0a] p-8 md:p-12 h-full flex flex-col"
//               >
//                 <div className="flex items-center justify-between">
//                   <span className="overline">Estimated total</span>
//                   {result?.qualifiesOffer && (
//                     <span data-testid="calc-offer-badge" className="inline-flex items-center gap-2 border border-[#e60000] text-[#e60000] px-3 py-1 text-[10px] uppercase tracking-[0.22em]">
//                       <Sparkles size={12} /> Offer applied
//                     </span>
//                   )}
//                 </div>

//                 <div className="mt-8 flex items-baseline gap-4">
//                   <span data-testid="calc-total" className="font-mono-data text-6xl md:text-8xl text-white">
//                     {result ? `₹${fmt(result.total)}` : "—"}
//                   </span>
//                   <span className="text-neutral-500">total + GST</span>
//                 </div>

//                 <div className="mt-12 grid grid-cols-2 gap-6">
//                   <Metric label="Per person / year" value={result ? `₹${result.rate}` : "—"} />
//                   <Metric label="Tier applied" value={result ? result.tier.toUpperCase() : "—"} testid="calc-tier" />
//                   <Metric label="Participants" value={result ? fmt(Number(participants)) : "—"} />
//                   <Metric label="Years" value={result ? fmt(Number(years)) : "—"} />
//                 </div>

//                 {result && result.savings > 0 && (
//                   <div data-testid="calc-savings" className="mt-10 border border-[#e60000]/40 bg-[#e60000]/5 p-6">
//                     <div className="overline text-[#e60000] mb-2">You save</div>
//                     <div className="font-mono-data text-3xl text-white">₹{fmt(result.savings)}</div>
//                     <div className="text-neutral-400 text-sm mt-2">
//                       Compared to standard tier (₹{fmt(result.standardTotal)}).
//                     </div>
//                   </div>
//                 )}

//                 {result && !result.qualifiesOffer && (Number(participants) >= 1 && Number(years) >= 1) && (
//                   <div className="mt-10 border border-white/10 p-6">
//                     <div className="overline mb-2">Unlock the offer tier</div>
//                     <div className="text-neutral-300 text-sm leading-relaxed">
//                       Reach at least <span className="text-white">25 participants</span> and at
//                       least <span className="text-white">5 years</span> of retention to switch to
//                       the discounted offer rate automatically.
//                     </div>
//                   </div>
//                 )}

//                 <div className="mt-auto pt-10">
//                   <Link
//                     to="/contact"
//                     data-testid="calc-cta-contact"
//                     className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
//                   >
//                     Request onboarding <ArrowUpRight size={18} />
//                   </Link>
//                 </div>
//               </motion.div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// const PriceCard = ({ t, testid }) => (
//   <Reveal>
//     <div
//       data-testid={testid}
//       className={`h-full p-10 border ${t.accent ? "border-[#e60000]/50 bg-gradient-to-br from-[#1a0000] to-[#0a0000]" : "border-white/10 bg-[#0a0a0a]"}`}
//     >
//       <div className="flex items-center justify-between">
//         <span className="overline">{t.accent ? "Best value" : "Flexible"}</span>
//         {t.accent && (
//           <span className="inline-flex items-center gap-2 border border-[#e60000] text-[#e60000] px-3 py-1 text-[10px] uppercase tracking-[0.22em]">
//             <Sparkles size={12} /> Offer
//           </span>
//         )}
//       </div>
//       <h3 className="font-serif-display text-3xl md:text-4xl mt-8">{t.name}</h3>
//       <div className="mt-8 flex items-baseline gap-3">
//         <span className="font-mono-data text-6xl md:text-7xl text-white">{t.price}</span>
//         <span className="text-neutral-500">{t.unit}</span>
//       </div>
//       <div className="mt-6 space-y-1 text-neutral-400 text-sm">
//         {t.conditions.map((c) => <div key={c}>• {c}</div>)}
//       </div>
//       <div className="mt-6 font-mono text-xs text-neutral-500">Formula: {t.formula}</div>
//       <ul className="mt-8 space-y-3 text-neutral-300 text-[15px]">
//         {t.features.map((f) => (
//           <li key={f} className="flex items-start gap-3">
//             <Check size={16} className={`mt-1 ${t.accent ? "text-[#e60000]" : "text-white"}`} strokeWidth={2} />
//             {f}
//           </li>
//         ))}
//       </ul>
//     </div>
//   </Reveal>
// );

// const Metric = ({ label, value, testid }) => (
//   <div className="border-l border-white/10 pl-4">
//     <div className="overline mb-2">{label}</div>
//     <div data-testid={testid} className="font-mono-data text-2xl text-white">{value}</div>
//   </div>
// );
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Sparkles, ArrowUpRight } from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import { Input } from "../components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";
import { Helmet } from "react-helmet-async";

const tiers = [
  {
    kind: "certificate",
    name: "Certificate Management · Offer",
    price: "₹1",
    crossedPrice: "₹3",
    unit: "/ person / year + GST",
    conditions: ["Minimum 25 candidates", "Minimum 5 years of access"],
    formula: "Candidates × Years × ₹1",
    accent: true,
    features: [
      "Secure cloud storage",
      "CSV bulk generation",
      "QR code verification",
      "5+ years active access",
      "Priority support",
    ],
  },
  {
    kind: "certificate",
    name: "Certificate Management · Standard",
    price: "₹5",
    crossedPrice: "₹10",
    unit: "/ person / year + GST",
    conditions: ["Minimum 10 candidates","Minimum 1 year access"],
    formula: "Candidates × Years × ₹5",
    features: [
      "Secure cloud storage",
      "CSV or manual generation",
      "QR code verification",
      "Flexible access (1 yr+)",
      "Email support",
    ],
  },
  {
    kind: "conference_paper",
    name: "Certificate + Paper · Offer",
    price: "₹5",
    crossedPrice: "₹10",
    unit: "/ presenter / year + GST",
    conditions: ["Minimum 25 presenters", "Minimum 5 years access"],
    formula: "Presenters × Years × ₹5",
    accent: true,
    features: [
      "Certificate generation",
      "Individual PDF paper display",
      "Paper–certificate linking",
      "5+ years active access",
      "Priority support",
    ],
  },
  {
    kind: "conference_paper",
    name: "Certificate + Paper · Standard",
    price: "₹15",
    crossedPrice: "₹25",
    unit: "/ presenter / year + GST",
    conditions: ["Minimum 10 candidates","Minimum 1 year access"],
    formula: "Presenters × Years × ₹15",
    features: [
      "Certificate generation",
      "Individual PDF paper display",
      "Paper–certificate linking",
      "Flexible access (1 yr+)",
      "Email support",
    ],
  },
];

const calculatePrice = (service, participants, years) => {
  const p = Number(participants) || 0;
  const y = Number(years) || 0;
  if (!p || !y) return null;
  const isCert = service === "certificate";
  const offerRate = isCert ? 1 : 5;
  const stdRate = isCert ? 5 : 15;
  const qualifiesOffer = p >= 25 && y >= 5;
  const rate = qualifiesOffer ? offerRate : stdRate;
  const total = p * y * rate;
  const standardTotal = p * y * stdRate;
  const savings = Math.max(0, standardTotal - total);
  return {
    tier: qualifiesOffer ? "offer" : "standard",
    rate, total, standardTotal, savings, qualifiesOffer,
  };
};

export default function Pricing() {
  const [service, setService] = useState("certificate");
  const [participants, setParticipants] = useState(100);
  const [years, setYears] = useState(5);

  const result = useMemo(() => calculatePrice(service, participants, years), [service, participants, years]);
  const fmt = (n) => n?.toLocaleString("en-IN");

  return (
    <div data-testid="page-pricing">
      <Helmet>
        <title>
          Pricing | JustZeta
        </title>

        <meta
          name="description"
          content="Affordable pricing for long-term certificate management and research paper display starting at ₹1 per participant per year on eligible plans."
        />
        <meta property="og:type" content="website" />

        <meta property="og:site_name" content="JustZeta" />

        <meta property="og:title"
          content="JustZeta - Certificate Management Platform"
        />

        <meta property="og:description"
          content="Generate, manage, and verify digital certificates and research papers."
        />

        <meta property="og:image"
          content="https://justzeta.com/logo.png"
        />

        <meta property="og:url"
          content="https://justzeta.com/pricing"
        />
        <meta name="twitter:card" content="summary_large_image"/>

        <meta
          name="twitter:title"
          content="JustZeta"
        />

        <meta
          name="twitter:description"
          content="Simple, transparent pricing for certificate generation and management."
        />

        <meta
          name="twitter:image"
          content="https://justzeta.com/logo.png"
        />
        <link
          rel="canonical"
          href="https://justzeta.com/pricing"
        />
      </Helmet>

      {/* HEADER */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={1}>Pricing</SectionLabel>

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
              Simple pricing for
              <br />
              <span className="italic text-[#e60000]">
                certificate management.
              </span>
            </h1>

            <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
              Pay only for the participants you manage and the years of access you choose.
              No hidden fees, no recurring subscriptions, and no unexpected costs.
            </p>
          </div>
        </div>
      </section>

      {/* CERTIFICATE TIERS */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={2}>Certificate Management</SectionLabel>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-6 max-w-3xl leading-[1.05]">
            Core generation. <span className="text-[#e60000]">Everything you need to issue and verify.</span>
          </h2>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
            {tiers.filter((t) => t.kind === "certificate").map((t, i) => (
              <PriceCard key={t.name} t={t} testid={`price-card-certificate-${i}`} />
            ))}
          </div>
        </div>
      </section>

      {/* CONFERENCE PAPER TIERS */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={3}>Conference Certificate + Research Paper</SectionLabel>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-6 max-w-3xl leading-[1.05]">
            Certificates <span className="text-[#e60000]">and</span> individual PDF papers, together.
          </h2>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
            {tiers.filter((t) => t.kind === "conference_paper").map((t, i) => (
              <PriceCard key={t.name} t={t} testid={`price-card-paper-${i}`} />
            ))}
          </div>
        </div>
      </section>

      {/* CALCULATOR */}
      <section className="border-b border-white/10 py-24 md:py-32 relative overflow-hidden">
        <div className="absolute inset-0 opacity-40 pointer-events-none"
             style={{ backgroundImage: "radial-gradient(circle at 20% 30%, rgba(230,0,0,0.10), transparent 55%)" }} />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={4}>Interactive Calculator</SectionLabel>
          <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
            Compute your certificate budget <span className="text-[#e60000]">in seconds.</span>
          </h2>

          <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Inputs */}
            <div className="lg:col-span-5 border border-white/10 p-8 md:p-10 bg-[#0a0a0a] space-y-8">
              <div>
                <label className="overline block mb-3">Service Type</label>
                <Select value={service} onValueChange={setService}>
                  <SelectTrigger
                    data-testid="calc-service-select"
                    className="bg-transparent border-0 border-b border-white/15 rounded-none focus:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white [&_svg]:text-neutral-400"
                  >
                    <SelectValue placeholder="Choose a service" />
                  </SelectTrigger>
                  <SelectContent className="bg-[#0a0a0a] border border-white/15 rounded-none">
                    <SelectItem value="certificate" data-testid="calc-service-certificate">Certificate Management</SelectItem>
                    <SelectItem value="conference_paper" data-testid="calc-service-paper">Certificate + Research Paper</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div>
                <label className="overline block mb-3">Number of Participants</label>
                <Input
                  type="number"
                  data-testid="calc-participants-input"
                  min={1}
                  value={participants}
                  onChange={(e) => setParticipants(e.target.value)}
                  className="bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white font-mono-data"
                />
              </div>

              <div>
                <label className="overline block mb-3">Number of Years (Access)</label>
                <Input
                  type="number"
                  data-testid="calc-years-input"
                  min={1}
                  value={years}
                  onChange={(e) => setYears(e.target.value)}
                  className="bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white font-mono-data"
                />
              </div>

              <div className="pt-4 text-xs text-neutral-500 leading-relaxed">
                Offer tier applies when you meet the volume threshold: 25+ participants and 5+
                years. Otherwise, standard rates apply.
              </div>
            </div>

            {/* Output */}
            <div className="lg:col-span-7">
              <motion.div
                key={`${service}-${participants}-${years}`}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="border border-white/10 bg-[#0a0a0a] p-8 md:p-12 h-full flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <span className="overline">Estimated total</span>
                  {result?.qualifiesOffer && (
                    <span data-testid="calc-offer-badge" className="inline-flex items-center gap-2 border border-[#e60000] text-[#e60000] px-3 py-1 text-[10px] uppercase tracking-[0.22em]">
                      <Sparkles size={12} /> Offer applied
                    </span>
                  )}
                </div>

                <div className="mt-8 flex items-baseline gap-4">
                  <span data-testid="calc-total" className="font-mono-data text-6xl md:text-8xl text-white">
                    {result ? `₹${fmt(result.total)}` : "—"}
                  </span>
                  <span className="text-neutral-500">total + GST</span>
                </div>

                <div className="mt-12 grid grid-cols-2 gap-6">
                  <Metric label="Per person / year" value={result ? `₹${result.rate}` : "—"} />
                  <Metric label="Tier applied" value={result ? result.tier.toUpperCase() : "—"} testid="calc-tier" />
                  <Metric label="Participants" value={result ? fmt(Number(participants)) : "—"} />
                  <Metric label="Years" value={result ? fmt(Number(years)) : "—"} />
                </div>

                {result && result.savings > 0 && (
                  <div data-testid="calc-savings" className="mt-10 border border-[#e10000]/40 bg-[#e60000]/5 p-6">
                    <div className="overline text-white mb-2">You save</div>
                    <div className="font-mono-data text-3xl text-[#e60000]">₹{fmt(result.savings)}</div>
                    <div className="text-white text-sm mt-2">
                      Compared to standard tier (₹{fmt(result.standardTotal)}).
                    </div>
                  </div>
                )}

                {result && !result.qualifiesOffer && (Number(participants) >= 1 && Number(years) >= 1) && (
                  <div className="mt-10 border border-white/10 p-6">
                    <div className="overline mb-2">Unlock the offer tier</div>
                    <div className="text-neutral-300 text-sm leading-relaxed">
                      Reach at least <span className="text-white">25 participants</span> and at
                      least <span className="text-white">5 years</span> of access to switch to
                      the discounted offer rate automatically.
                    </div>
                  </div>
                )}

                <div className="mt-auto pt-10">
                  <Link
                    to="/contact"
                    data-testid="calc-cta-contact"
                    className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
                  >
                    Request onboarding <ArrowUpRight size={18} />
                  </Link>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

const PriceCard = ({ t, testid }) => (
  <Reveal>
    <div
      data-testid={testid}
      className={`h-full p-10 border ${t.accent ? "border-[#e60000]/50 bg-gradient-to-br from-[#1a0000] to-[#0a0000]" : "border-white/10 bg-[#0a0a0a]"}`}
    >
      <div className="flex items-center justify-between">
        <span className="overline">{t.accent ? "Best value" : "Flexible"}</span>
        {t.accent && (
          <span className="inline-flex items-center gap-2 border border-[#e60000] text-[#e60000] px-3 py-1 text-[10px] uppercase tracking-[0.22em]">
            <Sparkles size={12} /> Offer
          </span>
        )}
      </div>
      <h3 className="font-serif-display text-3xl md:text-4xl mt-8">{t.name}</h3>
      <div className="mt-8 flex items-baseline gap-3">
        <span className="font-mono-data text-6xl md:text-7xl text-white">
          {t.crossedPrice && (
            <span className="text-3xl md:text-4xl text-neutral-500 line-through mr-3 opacity-60">
              {t.crossedPrice}
            </span>
          )}
          {t.price}
        </span>
        <span className="text-neutral-500">{t.unit}</span>
      </div>
      <div className="mt-6 space-y-1 text-neutral-400 text-sm">
        {t.conditions.map((c) => <div key={c}>• {c}</div>)}
      </div>
      <div className="mt-6 font-mono text-xs text-neutral-500">Formula: {t.formula}</div>
      <ul className="mt-8 space-y-3 text-neutral-300 text-[15px]">
        {t.features.map((f) => (
          <li key={f} className="flex items-start gap-3">
            <Check size={16} className={`mt-1 ${t.accent ? "text-[#e60000]" : "text-white"}`} strokeWidth={2} />
            {f}
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

const Metric = ({ label, value, testid }) => (
  <div className="border-l border-white/10 pl-4">
    <div className="overline mb-2">{label}</div>
    <div data-testid={testid} className="font-mono-data text-2xl text-white">{value}</div>
  </div>
);